import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "className", "spacing"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MEDIA_ALIGNMENT_TYPES, MEDIA_SPACING } from './MediaConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIMedia(props) {
  const {
      align,
      className,
      spacing
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames("media private-media", MEDIA_SPACING[spacing], className, align && MEDIA_ALIGNMENT_TYPES[align])
  }));
}
UIMedia.displayName = 'UIMedia';
UIMedia.propTypes = {
  align: PropTypes.oneOf(Object.keys(MEDIA_ALIGNMENT_TYPES)),
  children: PropTypes.node.isRequired,
  spacing: PropTypes.oneOf(Object.keys(MEDIA_SPACING)).isRequired
};
UIMedia.defaultProps = {
  spacing: 'small'
};